import _ from 'lodash';

export function cycleUrl(id) {
  return `/cycles/${id}/`;
}

export function hasReviewees(employee, cycles) {
  return _.some(
    cycles,
    cycle => _.some(cycle.reviewers, r => r.reviewerId === employee.id)
  );
}
